import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react'

export const ehrApi = createApi({
  baseQuery: fakeBaseQuery(),
  reducerPath: 'ehr',
  endpoints: () => ({}),
})

export const ehrReducers = ehrApi.reducer
export const ehrActions = ehrApi.internalActions
export const ehrMiddleware = ehrApi.middleware
